import { VStack, Box } from '@chakra-ui/react'
import NoteContainer from '../components/NoteContainer'
import ModuleContainer from '../components/ModuleContainer'
import CategoryContainer from '../components/CategoryContainer'
import TaskTitle from '../components/TaskTitle'
import TaskBreadcrumb from '../components/TaskBreadcrumb'
import TaskDescription from '../components/TaskDescription'
import GeneralContainer from '../components/GeneralContainer'

export default function N25_10_02() {
  return (
    <NoteContainer date={'02/10/2025'} version="20.7.0">
      <VStack w="full">
        <GeneralContainer>
          <VStack w="full">
            <CategoryContainer category="ADJUSTMENTS">
              <Box>
                <TaskTitle>Ordenação ajustada em criações de questões no formulário</TaskTitle>
                <TaskBreadcrumb>Formulários/ questões</TaskBreadcrumb>
                <TaskDescription>
                  Agora, ao criar uma questão, ela irá para a última posição do formulário
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </GeneralContainer>
        <ModuleContainer moduleName="SERVICES_LETTER">
          <VStack w="full">
            <CategoryContainer category="ADJUSTMENTS">
              <Box>
                <TaskTitle>Alerta na edição</TaskTitle>
                <TaskBreadcrumb>Serviços/ Perfil do serviço</TaskBreadcrumb>
                <TaskDescription>
                  Caso o serviço possua o campo de solicitação anônima marcado e algum campo pessoal obrigatório para a
                  solicitação, uma mensagem irá aparecer no topo da página, pois essas duas propriedades marcadas de
                  forma simultâneas podem causar problemas de parametrização
                </TaskDescription>
              </Box>
            </CategoryContainer>
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Correção do campo de ações do serviço</TaskTitle>
                <TaskBreadcrumb>Serviços/ Perfil do serviço</TaskBreadcrumb>
                <TaskDescription>
                  Correção do erro que impossibilidade editar o campo de ações do serviço
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
        <ModuleContainer moduleName="INSTITUTIONAL_MANAGEMENT">
          <VStack w="full">
            <CategoryContainer category="FEATURE">
              <Box>
                <TaskTitle>Visualização por tabela das solicitações de vínculos</TaskTitle>
                <TaskBreadcrumb>Solicitações de vínculos</TaskBreadcrumb>
                <TaskDescription>
                  Adicionada a visualiação por tabela. Agora na página, pode-se alternar a visualização entre tabela e
                  cartão
                </TaskDescription>
              </Box>
            </CategoryContainer>
            <CategoryContainer category="ADJUSTMENTS">
              <Box>
                <TaskTitle>Ajuste no resposivo</TaskTitle>
                <TaskBreadcrumb>Solicitações de vínculos</TaskBreadcrumb>
                <TaskDescription>
                  Ajustado a visualização do filtro de status na versão para dispositivos móveis
                </TaskDescription>
              </Box>
              <Box>
                <TaskTitle>Retirada ordenação</TaskTitle>
                <TaskBreadcrumb>Solicitações de vínculos</TaskBreadcrumb>
                <TaskDescription>Foi retirada a ordenação &apos;Pendentes primeiro&apos;</TaskDescription>
              </Box>
              <Box>
                <TaskTitle>Marcador com filtro no cartão da solicitação de vínculo</TaskTitle>
                <TaskBreadcrumb>Solicitações de vínculos</TaskBreadcrumb>
                <TaskDescription>
                  Ao utilizar o filtro rápido para buscar uma solicitação de vínculo, o nome da pessoa filtrada ficará
                  com uma marcação, facilitando a visualização
                </TaskDescription>
              </Box>
              <Box>
                <TaskTitle>Botão de ajuda na filtragem rápida</TaskTitle>
                <TaskBreadcrumb>Solicitações de vínculos</TaskBreadcrumb>
                <TaskDescription>
                  Adicionado botão de ajuda que mostrar quais campos poderão ser filtrados na filtragem rápida
                </TaskDescription>
              </Box>
              <Box>
                <TaskTitle>Correção de nomenclatura</TaskTitle>
                <TaskBreadcrumb>Grupos</TaskBreadcrumb>
                <TaskDescription>Correção da nomenclatura na aba de permissões</TaskDescription>
              </Box>
            </CategoryContainer>
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Correção do link para o perfil da pessoa</TaskTitle>
                <TaskBreadcrumb>Solicitações de vínculos</TaskBreadcrumb>
                <TaskDescription>Corrigido o link do botão para ir ao perfil da pessoa unificada</TaskDescription>
              </Box>
              <Box>
                <TaskTitle>Correção da paginação padrão</TaskTitle>
                <TaskBreadcrumb>Solicitações de vínculos</TaskBreadcrumb>
                <TaskDescription>
                  Corrigida a paginação padrão da página que mostrava 15 elementos, porém listava 20 elementos
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
        <ModuleContainer moduleName="CITIZEN_PORTAL">
          <VStack w="full">
            <CategoryContainer category="FEATURE">
              <Box>
                <TaskTitle important={true}>Opção de solicitação anônima</TaskTitle>
                <TaskBreadcrumb>Serviços/ Solicitação de serviço</TaskBreadcrumb>
                <TaskDescription>
                  Agora, quando o serviço tiver a opção de solicitação anônima ativada, uma caixa de marcação aparecerá
                  no final do formulário de solicitação do serviço onde o usuário poderá marcar para solicitar de forma
                  anônima
                </TaskDescription>
              </Box>
              <Box>
                <TaskTitle important={true}>Alterando comprovante de solicitação</TaskTitle>
                <TaskBreadcrumb>Serviços/ Solicitação de serviço</TaskBreadcrumb>
                <TaskDescription>
                  Agora, ao solicitar um serviço, será apresentando o próprio documento de solicitação do serviço como
                  comprovante
                </TaskDescription>
              </Box>
              <Box>
                <TaskTitle important={true}>Página pública para visualizar documento</TaskTitle>
                <TaskBreadcrumb>Arquivo</TaskBreadcrumb>
                <TaskDescription>
                  No documento de solicitação de serviço, quando faz referência a alguma arquivo, irá apresentar uma URL
                  clicável que irá ser direcionada para a visualização de tal arquivo no navegador
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
        <ModuleContainer moduleName="REGULATION">
          <VStack w="full">
            <CategoryContainer category="ADJUSTMENTS">
              <Box>
                <TaskTitle>Tratamento de solicitação anônima na listagem</TaskTitle>
                <TaskBreadcrumb>Painel de solicitações</TaskBreadcrumb>
                <TaskDescription>
                  Agora quando se tem uma solicitação anômima, o nome do solicitante não aparece e sim uma tag com o
                  termo &apos;Solicitação anônima&apos;
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
      </VStack>
    </NoteContainer>
  )
}
